import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/components/login";
import Home from "@/components/home";
import User from "@/components/user";
import Ingoods from "@/components/ingoods";
import Outgoods from "@/components/outgoods/outgoods";
import Kucun from "@/components/showData/kucun";
import Outdata from "@/components/showData/outdata";
import Indata from "@/components/showData/indata";
import Yuedata from "@/components/showData/yuedata";
import Collection from "@/components/collection";
import Addcol from "@/components/addcol";
import Announcement from "@/components/announcement";
import Addannouncement from "@/components/addannouncement";
import Analysis from "@/components/analysis";
import Annoudetails from "@/components/annoudetails";
import NotFound from "@/components/NotFound";
import Index from "@/components/Index";
import Firstpage from "@/components/firstpage";

Vue.use(VueRouter)

const routes = [
  { path: '*', name: 'NotFound', component: NotFound },
  { path: '/', redirect: '/firstpage' },
  { path: '/login', component: Login },
  { path: '/home', component: Home, redirect: '/firstpage', children: [
      { path: '/user', component: User },
      { path: '/ingoods', component: Ingoods },
      { path: '/outgoods/outgoods', component: Outgoods },
      { path: '/showData/kucun', component: Kucun },
      { path: '/showData/outdata', component: Outdata },
      { path: '/showData/Indata', component: Indata },
      { path: '/showData/yuedata', component: Yuedata },
      { path: '/index', component: Index },
      { path: '/firstpage', component: Firstpage },
      { path: '/collection', component: Collection },
      { path: '/collection/add', component: Addcol },
      { path: '/announcement', component: Announcement },
      { path: '/announcement/add', component: Addannouncement },
      { path: '/data-analysis', component: Analysis },
      { path: '/announcement/details', component: Annoudetails },
    ] },
]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') next()
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})

export default router
